
    import Vue from "vue";
    import Component from "vue-class-component";
    import { BModal } from "bootstrap-vue";
    import { log } from "handlebars";

    @Component
    export default class DocumentDigitalRepresentationModal extends Vue {
        $refs!: { modal: BModal };

        printTemplateHtml = "";

        show(printTemplateHtml: string) {
            this.printTemplateHtml = printTemplateHtml;
            this.printTemplateHtml +=
                "<style>body {background: transparent;} .page-A5 {box-shadow: none; border-color: #e9ecef;} </style>";
            this.$refs.modal.show();
        }
    }
